module.exports = __webpack_public_path__ + "img/img_ticket_center_fanjin.980f1857.png";